import { createSelector } from 'reselect';
import { RootState } from '../redux';

export const selectGlobalGuides = createSelector(
  ({ globalGuides }: RootState) => globalGuides,
  ({ allIds, byId }) => (byId ? allIds.map((id) => byId[id]) : null)
);
